import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { CompanyFeaturesResponse } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const COMPANY_FEATURES_QUERY_KEY = 'company_features';

export const useCompanyFeaturesQuery = (url: string) =>
  useQuery({
    queryKey: [COMPANY_FEATURES_QUERY_KEY, url],
    queryFn: () =>
      HttpClient.request<CompanyFeaturesResponse>({
        method: 'GET',
        url,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!url,
  });
